module.exports = __webpack_public_path__ + "media/Asl Sample Video-8.e82e8f2d.mp4";